import { QnA } from '@bridebook/toolbox/src/seo-facets/get-seo-data';

/**
 * See required fields of the schema:
 * https://schema.org/FAQPage
 *
 * Schema validator: https://developers.google.com/search/docs/advanced/structured-data
 */
interface IMicroData {
  '@context': 'https://schema.org';
  '@type': 'FAQPage';
  mainEntity: {
    '@type': 'Question';
    name: string;
    acceptedAnswer: {
      '@type': 'Answer';
      text: string;
    };
  }[];
}

export const generateFaqPageMicrodata = (faqs: QnA[]): IMicroData | null => {
  if (faqs.length === 0) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
};
